import { toast } from '@/hooks/use-toast';
import axios from 'axios';



export const fetchLinkedinCandidates = async (queryParams: Map<string, string>) => {
    try {
        const apiKey = (import.meta.env.VITE_GOOGLE_API_KEY || process.env.VITE_GOOGLE_API_KEY || '').replace(/['"]+/g, '');
        const searchEngineId = (import.meta.env.VITE_GOOGLE_SEARCH_ENGINE_ID || process.env.VITE_GOOGLE_SEARCH_ENGINE_ID || '').replace(/['"]+/g, '');
        
        if (!apiKey || !searchEngineId) {
            toast({
                title: "LinkedIn Search not available", duration: 2000,
                console: "error",   
              });
            return [];
        }
        const location = queryParams.get('location') || '';
        const skills = queryParams.get('skills') || '';
        const experience = queryParams.get('experience') || '';
        const openToWork = queryParams.get('open_to_work') || '';
        console.log(`Fetching LinkedIn candidates with skills: ${skills} and location: ${location} and open to work: ${openToWork}`);
        const query = `site:linkedin.com/in (${openToWork}) (${skills}) (${location}) (${experience})`;

        const url = `https://www.googleapis.com/customsearch/v1`;
        const response = await axios.get(url,
            {
                params: {
                    key: apiKey,
                    cx: searchEngineId,
                    q: query,
                }
            }
        );
        console.log(response);
        const linkedCandidates = response.data.items.map(item => ({
            name: item.title,
            linkedInUrl: item.link,
            source: "linkedin",
        }));

        console.log(linkedCandidates);
        return linkedCandidates;
    } catch (error) {
        console.log(error);
        toast({
            title: "LinkedIn Search not available",
            status: "success",
            duration: 2000, 
        });
        return [];
    }
};